import MetaTags from '@/components/meta-tag/meta-tag';

const Page = () => {
    return (
        <>
            <MetaTags />
            <div className="board-member-page">
                <div className="container-member">
                    <div className="profile">
                        <img
                            className="profile-img"
                            src="/img/kaushal-panchal.webp"
                            alt="Kaushal Panchal"
                            title="Kaushal Panchal"
                            loading="lazy"
                        />
                        <h1 className="profile-name">Kaushal Panchal</h1>
                        <p className="profile-description">Design & Sales Manager</p>
                    </div>
                    <div className="links">
                        <a href="https://api.whatsapp.com/send/?phone=919712992717&text=Hi" className="link" target="_blank">
                            <div>
                                <img className="link-icon mr-4" src="/img/whatsapp.svg" alt="WhatsApp" title="WhatsApp" loading="lazy" />
                                Message on WhatsApp
                            </div>
                            <img className="" src="/img/right-arrow.svg" alt="right-arrow" title="right-arrow" loading="lazy" />
                        </a>
                        <a href="skype:kaushal.moweb?chat" className="link" target="_blank">
                            <div>
                                <img className="link-icon mr-4" src="/img/skype.svg" alt="skype" title="skype" loading="lazy" />
                                Message on Skype
                            </div>
                            <img className="" src="/img/right-arrow.svg" alt="right-arrow" title="right-arrow" loading="lazy" />
                        </a>
                        <a href="https://linkedin.com/in/kaushalpanchal" className="link" target="_blank">
                            <div>
                                <img className="link-icon mr-4" src="/img/LinkedIn.svg" alt="LinkedIn" title="LinkedIn" loading="lazy" />
                                Connect on LinkedIn
                            </div>
                            <img className="" src="/img/right-arrow.svg" alt="right-arrow" title="right-arrow" loading="lazy" />
                        </a>
                        <a href="mailto:sales@moweb.com" className="link" target="_blank">
                            <div>
                                <img className="link-icon mr-4" src="/img/email.svg" alt="email" title="email" loading="lazy" />
                                Send Email
                            </div>
                            <img className="" src="/img/right-arrow.svg" alt="right-arrow" title="right-arrow" loading="lazy" />
                        </a>
                        <a href="https://www.moweb.com" className="link" target="_blank">
                            <div>
                                <img className="link-icon mr-4" src="/img/website.svg" alt="Website" title="Website" loading="lazy" />
                                Visit Website
                            </div>
                            <img className="" src="/img/right-arrow.svg" alt="right-arrow" title="right-arrow" loading="lazy" />
                        </a>
                    </div>
                </div>
            </div>
        </>
    );
};

export default Page;
